import React from 'react';

const Vue_Components = () => {
  return (
    <div>
      <h1>Vue_Components Component</h1>
      <p>This is the Vue_Components tutorial page.</p>
    </div>
  );
}

export default Vue_Components;
